import { Agency } from '../interfaces/agency';
import { UserRole } from './user-role';
import { flatMap, map } from 'lodash';
import { Permission } from './permission';
import { Location } from './location';

export class User {
  displayName: string;
  name: string;
  username: string;
  uid: string;
  sid: string;
  pid: number;
  lastName: string;
  firstName: string;
  userGuid: string;
  email: string;
  preferred_username: string;
  sub: string;
  doeEmployeeId: string;
  currentAgency?: Agency;
  userRoles: UserRole[];
  personSk: string;
  permissions: Permission[];
  selectedRole: UserRole;
  selectedLocation: Location;
  locationsForSelectedRole: Location[];
  isMDE: boolean;
  isMDESupervisor: boolean;
  isSupervisor: boolean;
  agencySk: string[];
  isGlobalUser: boolean;
  isViewOnly: boolean;
  loginID: string;
  csLocation: string;
  roleType: number;
  constructor(data: any) {
    this.displayName = data?.displayName;
    this.name = data?.name;
    this.username = data?.name;
    this.uid = data?.uid;
    this.sid = data?.sid;
    this.pid = data?.pid;
    this.userGuid = data?.userGuid;
    this.preferred_username = data?.preferred_username;
    this.firstName = data?.firstName || data.given_name;
    this.lastName = data?.lastName || data.family_name;
    this.sub = data?.sub;
    this.email = data?.EmailAddress || data?.email;
    this.personSk = data?.personSk;
    this.doeEmployeeId = data?.doeEmployeeId;
    this.currentAgency = data?.currentAgency;
    this.selectedLocation = data?.selectedLocation;
    this.selectedRole = data?.selectedRole;
    this.userRoles = data?.userRoles
      ? map(data.userRoles, (r: any) => new UserRole(r))
      : undefined;
    this.permissions = this?.userRoles
      ? flatMap(this.userRoles, (r: UserRole) => r.userPermissions)
      : undefined;
    this.isMDE = data?.isMDE;
    this.isMDESupervisor = data?.isMDESupervisor;
    this.isSupervisor = data?.isSupervisor;
    this.agencySk = data?.agencySk;
    this.isGlobalUser = data?.isGlobalUser;
    this.isViewOnly = data?.isViewOnly;
    this.loginID = data?.loginID;
    this.csLocation = data?.csLocation;
    this.roleType = data?.roleType;
  }
}
